import type { FetchFunction } from 'relay-runtime';

export type MiddlewareFactory = (fetchFn: FetchFunction) => FetchFunction;

export interface MiddlewareConfig {
	name: string;
	factory: MiddlewareFactory;
	enabled: boolean;
}

/**
 * Composes middleware functions into a single fetch function.
 * Middlewares applied in order (first wraps outermost).
 */
export const composeMiddlewares = (
	baseFetch: FetchFunction,
	middlewares: MiddlewareConfig[],
): FetchFunction => {
	return middlewares
		.filter((middleware) => middleware.enabled)
		.reduce((composedFetch, middleware) => {
			return middleware.factory(composedFetch);
		}, baseFetch);
};
